import React, { useState } from 'react';
import { Button } from '../ui/button';
import { Loader2 } from 'lucide-react';
import { updateUserSubscription } from '@/lib/db/services/subscriptionService';

interface SubscriptionActivationProps {
  userId: string;
  onSuccess?: () => void;
}

export function SubscriptionActivation({ userId, onSuccess }: SubscriptionActivationProps) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleActivateFreePlan = async () => {
    setLoading(true);
    setError(null);

    try {
      await updateUserSubscription(userId, {
        tier: 'FREE',
        startDate: new Date(),
        autoRenew: false,
        analysisCount: 0,
        lastResetDate: new Date()
      });
      
      onSuccess?.();
    } catch (err) {
      setError('Failed to activate subscription. Please try again.');
      console.error('Subscription activation error:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-4">
      {error && (
        <p className="text-sm text-red-500">{error}</p>
      )}
      <Button
        onClick={handleActivateFreePlan}
        disabled={loading}
        className="w-full"
      >
        {loading ? (
          <>
            <Loader2 className="w-4 h-4 mr-2 animate-spin" />
            Activating...
          </>
        ) : (
          'Activate Free Plan'
        )}
      </Button>
    </div>
  );
}